export default __webpack_public_path__ + "static/media/IMG-20190407-WA0000.2e08b574.jpg";